{
  "navbar": {
    "logout": "Skrá út"
  }
}
